import Card from '@/components/ui/Card'
import AnimatedNumber from '@/components/common/AnimatedNumber'
import { cn } from '@/lib/utils'
import type { TotalEstimate } from '@/types/cost'

interface CostResultCardProps {
  /** 총 예상 비용 */
  totalEstimate: TotalEstimate
  /** 추가 CSS 클래스 */
  className?: string
}

/** 금액을 만원 단위로 포맷 */
function formatManWon(amount: number): string {
  const man = Math.round(amount / 10000)
  return `${man.toLocaleString()}만원`
}

/**
 * 월 예상 비용 결과 카드 v2.0
 *
 * 그라데이션 배경 + 큰 숫자 강조.
 * 40~60대 사용자 고려: 크고 읽기 쉬운 숫자.
 */
export default function CostResultCard({
  totalEstimate,
  className,
}: CostResultCardProps) {
  return (
    <Card
      className={cn('border-0 overflow-hidden', className)}
      noPadding
    >
      <div
        className="flex flex-col items-center gap-3 py-8 px-6 text-center"
        style={{ background: 'var(--gradient-result)' }}
      >
        <p className="text-body font-semibold text-cb-gray-600">
          월 예상 비용
        </p>
        <p
          className="text-[2rem] font-bold leading-tight text-cb-primary text-amount"
          aria-label={`약 ${formatManWon(totalEstimate.min)}에서 ${formatManWon(totalEstimate.max)}`}
        >
          약{' '}
          <AnimatedNumber
            value={totalEstimate.min / 10000}
            duration={800}
            format={(v) => `${Math.round(v).toLocaleString()}`}
          />
          ~
          <AnimatedNumber
            value={totalEstimate.max / 10000}
            duration={1000}
            format={(v) => `${Math.round(v).toLocaleString()}`}
          />
          만원
        </p>
        <p className="text-body-sm text-cb-gray-500">
          감경, 비급여 항목에 따라 달라질 수 있어요
        </p>
      </div>
    </Card>
  )
}
